import React from 'react';
import PropTypes from 'prop-types';
import { CopyClipboard, withLoading } from '@adjust/dashboard-components';

const EditUserApiTokenContentBase = ({ authenticationToken, onReset, onCancel }) => (
  <div className="flex-one flex-box-column">
    <div className="flex-one content-inner">
      <p className="info small">{t('users.reset-api-token.message')}</p>

      <ul className="ul-list-transparent">
        <li className="flex-box-row flex-align-center">
          <div className="item-name token-value flex-one">{authenticationToken}</div>
          <div className="flex-auto">
            <CopyClipboard tooltipTitle={t('label.copy-token')} content={authenticationToken} />
          </div>
        </li>
      </ul>
    </div>

    <div className="flex-auto inner-panel-footer">
      <div className="flex-box-row">
        <button type="button" className="btn flex-one" onClick={onCancel}>
          {t('action.cancel')}
        </button>
        <button type="button" className="btn btn-main flex-one" onClick={onReset}>
          {t('action.reset-api-token')}
        </button>
      </div>
    </div>
  </div>
);

EditUserApiTokenContentBase.propTypes = {
  authenticationToken: PropTypes.string,
  onReset: PropTypes.func,
  onCancel: PropTypes.func,
};

const EditUserApiTokenContent = withLoading(EditUserApiTokenContentBase);

EditUserApiTokenContent.propTypes = {
  ...EditUserApiTokenContentBase.propTypes,
  isLoading: PropTypes.bool,
};

export { EditUserApiTokenContent };
